import { ReactNode } from 'react';
import { CloseButton, P2GBox, P2GDrawer, P2GText, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export interface IP2GMyAccountModalProps {
  preTitle?: ReactNode;
  title?: string;
  titleAdornment?: string | ReactNode;
  open: boolean;
  onClose: () => void;
  anchor?: 'left' | 'top' | 'right' | 'bottom';
  actions?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  height?: string;
  width?: string;
}

const useStyles = makeStyles<{ height?: IP2GMyAccountModalProps['height'] }>()((theme, { height }) => ({
  root: {
    '& .MuiDrawer-paper': {
      height: height
    }
  }
}));

export const P2GSidePanel: React.FC<React.PropsWithChildren<IP2GMyAccountModalProps>> = (props) => {
  const { classes } = useStyles(props);
  const xs = useP2GMediaQueryOnly('xs');
  const anchor = xs ? 'bottom' : props.anchor || 'bottom';
  const { t } = useTranslation(TranslationNamespaces.COMMON);

  return (
    <P2GDrawer open={props.open} onClose={props.onClose} anchor={anchor} classNames={classes.root}>
      <div style={anchor === 'right' || anchor === 'left' ? { width: props.width || '500px' } : {}}>
        <P2GBox display="flex" flexDirection="column" gap={2} p={2}>
          <P2GBox>
            <CloseButton
              handleOnClose={props.onClose}
              closeButtonText={t('SIDEPANEL_CLOSE_BUTTON', { defaultValue: 'Close' })}
            />
          </P2GBox>
          {props.preTitle && <P2GBox>{props.preTitle}</P2GBox>}
          {props.title && (
            <P2GBox display="flex" alignItems="center" justifyContent="space-between" flexWrap="nowrap" gap={2}>
              <P2GText variant="h2">{props.title}</P2GText>
              {props.titleAdornment && <P2GBox>{props.titleAdornment}</P2GBox>}
            </P2GBox>
          )}
          {props.children && <P2GBox>{props.children}</P2GBox>}
          {props.actions && <P2GBox>{props.actions}</P2GBox>}
        </P2GBox>
      </div>
    </P2GDrawer>
  );
};
